import React from "react";
import CenterMenu from "./CenterMenu";
import { Facebook, Twitter, YouTube, LinkedIn } from "@material-ui/icons";

function Footer() {
  const SocialStyle = "rounded-full border-2 border-whit p-2 mr-[5rem]";
  return (
    <div className=" footer flex flex-col items-center justify-start px-[5rem] bg-[#081730] h-[45rem] pt-[18rem] mt-[-10rem] relative z-[-1]">
      <CenterMenu />
      {/* Social icons */}
      <div className="flex w-[100%] justify-center mt-14">
        <div className={SocialStyle}>
          <Facebook />
        </div>{" "}
        <div className={SocialStyle}>
          <Twitter />
        </div>{" "}
        <div className={SocialStyle}>
          <YouTube />
        </div>{" "}
        <div className={SocialStyle}>
          <LinkedIn />
        </div>
      </div>
      {/* detail */}
      <span className="capitalize text-[1rem] text-gray-400 px-[15rem] text-center mt-[4rem]">
        I created this Music Master website for learning purpose Using react JS
        and tailwind . I Can Develop any kind of Front-End website.If you like
        my work, please contact me.
        <h6 className="text-gray-300"> Email: parvejsikder4433@gmail.com</h6>
      </span>
    </div>
  );
}

export default Footer;
